<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>
          {{ $tc('models.carrier', 2) }}
          <v-btn color="primary" outline @click="goTo('users', { userFiltersStore: true })"> {{ $t('back') }} </v-btn>
        </h1>
      </v-flex>

      <v-flex xs12>
        <v-data-table class="elevation-1"
                      :items="items"
                      :loading="loading"
                      hide-actions
                      hide-headers
                      item-key="carrier_id"
                      :no-data-text="$t('noDataAvailable')">
          <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>

          <template v-slot:items="props">
            <td class="pa-0 pt-3 pl-3">
              <v-checkbox
                v-model="props.item.active"
                @change="setUserCarrier(props.item)"
                :label="props.item.carrier_name"
              ></v-checkbox>
            </td>

            <td class="pa-0 pr-2 text-xs-right">
              <v-btn color="primary" flat icon @click="props.expanded = !props.expanded">
                <font-awesome-icon v-if="!props.expanded" icon="angle-left"></font-awesome-icon>
                <font-awesome-icon v-else icon="angle-down"></font-awesome-icon>
              </v-btn>
            </td>
          </template>

          <template v-slot:expand="props">
            <v-layout row wrap class="ma-1">
              <v-flex xs12 md4
                    v-for="service in props.item.services"
                    :key="service.id"
              >
                  <v-checkbox
                    v-model="props.item.service_ids"
                    @change="updateServices(props.item)"
                    :value="service.id"
                    :label="service.name"
                    :disabled="!props.item.active"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Carrier from '@/client/carrier'
import Service from '@/client/service'
import UserCarrier from '@/client/user-carrier'

export default {
  name: 'UserCarriersView',

  props: {},

  data () {
    return {
      carriers: [],
      services: [],
      userCarriers: [],
      items: [],
      loading: false
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
    async fetch () {
      this.loading = true
      this.carriers = await Carrier.all({ order: 'name', per_page: 2000 })
      this.services = await Service.all({ order: 'name', per_page: 2000, where: { carrier_id: this.carriers.map(o => o.id) } })
      this.userCarriers = await UserCarrier.all({ where: { user_id: this.$route.params.userId } })
      this.setItems()
      this.loading = false
    },

    setItems () {
      this.items = this.carriers.map(carrier => {
        const userCarrier = this.userCarriers.find(o => o.carrier_id === carrier.id) || (new UserCarrier())
        userCarrier.active = !!userCarrier.id
        userCarrier.services = this.services.filter(o => o.carrier_id == carrier.id)
        let serviceIds = userCarrier.service_ids
        if (userCarrier.active && (!serviceIds || !serviceIds.length)) {
          userCarrier.service_ids = userCarrier.services.map(o => o.id)
        }
        userCarrier.carrier_name = carrier.name
        if (!userCarrier.active) {
          userCarrier.carrier_id = carrier.id
          userCarrier.user_id = this.$route.params.userId
        }
        return userCarrier
      })
    },

    async setUserCarrier (item) {
      if (item.active) {
        item.service_ids = item.services.map(o => o.id)
        await item.save()
      } else {
        await UserCarrier.destroyById(item.id)
      }
      this.fetch()
    },

    async updateServices (item) {
      if (item.service_ids.length) {
        await item.save()
      } else {
        await UserCarrier.destroyById(item.id)
      }
      this.fetch()
    },
  },

  watch: {
  },

  async mounted () {
    this.fetch()
  }
}
</script>
